var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1Player(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ARTWORK",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.32,19.93v1H7.73V18h.86a.48.48,0,0,1,.55.55v.83a.48.48,0,0,1-.55.55Zm.23-1.32c0-.07,0-.1-.1-.1H8.32v.92h.13c.07,0,.1,0,.1-.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.31,18H9.9v2.43h.43V21h-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.6,18,12,21H11.4l-.05-.43H11l0,.43H10.4l.39-3Zm-.43.72L11,20h.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.67,19l.21-1h.56l-.5,1.91V21h-.59V20L11.85,18h.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.53,18h1.11v.53h-.51v.66h.48v.53h-.48v.71h.51V21H13.53Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,19.56a.35.35,0,0,1,.25.38v1h-.59V20c0-.07,0-.11-.1-.11h-.15V21h-.6V18h.89a.48.48,0,0,1,.55.55v.57A.42.42,0,0,1,16,19.56Zm-.34-.94c0-.07,0-.1-.11-.1h-.14v.82h.14a.1.1,0,0,0,.11-.11Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.47,3V16H10.93V6H9.71V4.22A2.24,2.24,0,0,0,10.65,4a2.52,2.52,0,0,0,.71-.66l.22-.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Player);
export default __webpack_public_path__ + "static/media/1_player.4030798bd9750ad42ea2d5445a9af6df.svg";
export { ForwardRef as ReactComponent };